import React, { useState, useRef, useEffect, useCallback } from "react";
import DefaultDataGrid from '../components/DefaultDataGrid';
import { DataGrid, GridToolbar, plPL, getGridStringOperators, GridActionsCellItem } from '@mui/x-data-grid';
import { useParams } from 'react-router';
import {
    Grid, TextField, Typography, Stack, Button, Dialog, DialogTitle, DialogActions, DialogContent, DialogContentText,
    Box, CircularProgress, Checkbox, Autocomplete, Divider, TextareaAutosize, Tooltip, Fab, Alert
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import SaveIcon from '@mui/icons-material/Save';
import { Link, useNavigate } from "react-router-dom";
import InputColumn from '../components/InputColumn'
import InputRow from '../components/InputRow'
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import { LoadingButton } from '@mui/lab';
import { enqueueSnackbar } from 'notistack';
import { query, flattenObj, unflattenObject } from '../App';
import config from '../config/default.json';
import DateField from "../components/DateField";
import AutocompleteText from '../components/AutocompleteText';
import TabsInput from "../components/TabsInput";
import RowEditPage from "../components/RowEditPage";
import { Files, Tool, LetterF, LetterS, LetterC, Printer, Archive } from 'tabler-icons-react';
import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import Person2RoundedIcon from '@mui/icons-material/Person2Rounded';
import LocalShippingRoundedIcon from '@mui/icons-material/LocalShippingRounded';
import QuestionMarkRoundedIcon from '@mui/icons-material/QuestionMarkRounded';
import DisabledByDefaultRoundedIcon from '@mui/icons-material/DisabledByDefaultRounded';
import MoneyOffRoundedIcon from '@mui/icons-material/MoneyOffRounded';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import CommentRoundedIcon from '@mui/icons-material/CommentRounded';
import ModeCommentOutlinedIcon from '@mui/icons-material/ModeCommentOutlined';
import ArchiveOutlinedIcon from '@mui/icons-material/ArchiveOutlined';
import KeyIcon from '@mui/icons-material/Key';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import WZTrackingBundle from '../components/WZTrackingBundle';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
const filterOperators = getGridStringOperators().filter(({ value }) =>
    ['equals', 'contains', 'startsWith', 'endsWith' /* add more over time */].includes(value),
);

const columns = [
    { field: 'id', headerName: 'Nr', filterOperators, maxWidth: 90, renderCell: formatId },
    { field: 'client.invoice.company', headerName: 'Firma', minWidth: 120, flex: 1, filterOperators },
    {
        field: 'products', headerName: 'Produkty', width: 600,
        renderCell: productCellRenderer
    },
    {
        field: 'product_name', headerName: 'Nazwa produktu', filterOperators, hideable: false, hide: true
    },
    {
        field: 'KOD', headerName: 'KOD', filterOperators, hideable: false, hide: true
    },
    {
        field: 'PO', headerName: 'PO', filterOperators, hideable: false, hide: true
    },
    {
        field: 'PMD', headerName: 'PMD', filterOperators, hideable: false, hide: true
    },
    {
        field: 'transport.transport', headerName: 'Transport', align: "center", maxWidth: 20,
        renderCell: transportCellRenderer
    },
    {
        field: 'comments', headerName: 'Komentarze', align: "center", width: 230,
        renderCell: commentsCellRenderer
    },
    {
        field: 'creation_date', headerName: 'Data utworzenia', width: 120, align: "center", filterOperators,
        renderCell: (props) => <span>{
            `${new Date(props.formattedValue).toLocaleDateString()} ${new Date(props.formattedValue).toLocaleTimeString()}`
        }</span>
    },
    {
        field: 'trader', headerName: 'Handlowiec',
        renderCell: traderCellRenderer, align: "center"
    },
    { field: 'transport.deadline', headerName: 'Ścisła data', type: 'boolean', maxWidth: 20, align: "center", filterOperators },
    {
        field: 'transport.completion_date', headerName: 'Data realizacji', width: 130, align: "center", filterOperators,
        renderCell: (props) => {
            let remainingDays = (new Date() - new Date(props.formattedValue)) * -1;
            remainingDays = Math.ceil(remainingDays / (1000 * 60 * 60 * 24));
            let color;
            if (remainingDays < 0) color = "red";
            else if (remainingDays == 0) color = "purple";
            else if (remainingDays <= 2) color = "#d5d500";
            else if (remainingDays > 2) color = "green";
            return <span style={{ color: color }}>{props.formattedValue}</span>;
        }
    },
    { field: 'client.delivery.login/email', headerName: 'Login/Email', minWidth: 150, flex: 1, hide: true, filterOperators },
    { field: 'client.delivery.surname', headerName: 'Numer telefonu', minWidth: 150, flex: 1, hide: true, filterOperators },
    { field: 'client.delivery.zip_code', headerName: 'Numer telefonu', minWidth: 150, flex: 1, hide: true, filterOperators },
    { field: 'client.delivery.address', headerName: 'NIP', hide: true, filterOperators },
    { field: 'client.delivery.city', headerName: 'Imie', hide: true, filterOperators },
    { field: 'client.contact.name', headerName: 'Nazwisko', hide: true, filterOperators },
    { field: 'client.contact.surname', headerName: 'Adres', hide: true, filterOperators },
    { field: 'client.contact.login/email', headerName: 'Kod pocztowy', hide: true, filterOperators },
    { field: 'client.contact.mobile_phone', headerName: 'Miasto', hide: true, filterOperators },
    { field: 'client.invoice.NIP', headerName: 'Imie', hide: true, filterOperators },
    { field: 'client.invoice.address', headerName: 'Adres', hide: true, filterOperators },
    { field: 'client.invoice.zip_code', headerName: 'Kod pocztowy', hide: true, filterOperators },
    { field: 'client.invoice.city', headerName: 'Kod pocztowy', hide: true, filterOperators },
]

const ORDER_POLL_INTERVAL = 30000;

function stableStringify(value) {
    if (value === null) return 'null';
    if (value === undefined) return 'undefined';
    if (value instanceof Date) return JSON.stringify(value.toISOString());
    if (typeof value === 'function') return JSON.stringify(value.toString());
    if (Array.isArray(value)) {
        return `[${value.map((item) => stableStringify(item)).join(',')}]`;
    }
    if (typeof value === 'object') {
        const keys = Object.keys(value).sort();
        return `{${keys.map((key) => `${JSON.stringify(key)}:${stableStringify(value[key])}`).join(',')}}`;
    }
    return JSON.stringify(value);
}

export function formatId(props) {
    let idString = String(props.value);
    let position = 2;
    if (new Date(props.row["creation_date"]) >= new Date("2024/01/01") && idString.length == 2) { }
    else if (new Date(props.row["creation_date"]) <= new Date("2023/12/31") && idString.length == 4) { }
    else idString = [idString.slice(0, position), "/", idString.slice(position)].join('');
    return (<div>{idString}</div>);
}
function traderCellRenderer(props) {
    const trader = props.formattedValue;
    return (
        trader['_id']
            ? <span>
                <Button href={`/traders/${trader['_id']}/lookup`} sx={{ color: "black" }}>{`${trader.name} ${trader.surname}`}</Button>
            </span>
            : <span>Brak</span>
    )
}
function commentsCellRenderer(props) {
    const commentsTooltips = [
        { label: "Graficy", name: "graphic_designers", color: "lightblue" },
        { label: "Druk", name: "printing", color: "yellow" },
        { label: "Introligatornia", name: "book_bindery", color: "orange" },
        { label: "Pakowanie", name: "packing", color: "brown" },
        { label: "Magazyn", name: "warehouse", color: "purple" },
        { label: "Faktury", name: "invoices", color: "red" },
    ];
    return (
        commentsTooltips.map(e => {
            if (props.formattedValue[e.name]) return <Tooltip
                title={`${e.label} - ${props.formattedValue[e.name]}`}>
                <CommentRoundedIcon sx={{ color: e.color, marginLeft: "5px" }} />
            </Tooltip>
        })
    )
}
function transportCellRenderer(props) {
    function TransportCellIcon(props) {
        switch (props.value) {
            case "PERSONAL":
                return <Tooltip title="Odbiór Osobisty"><Person2RoundedIcon /></Tooltip>;
            case "COURIER":
                return <Tooltip title="Wysyłka Kurierem"><LocalShippingRoundedIcon /></Tooltip>;
            case "DEDICATED":
                return <Tooltip title="Transport dedykowany"><LocalShippingRoundedIcon /></Tooltip>;
            case "OWN":
                return <Tooltip title="Zawozimy"><Person2RoundedIcon /></Tooltip>;
            case "TO_BE_AGREE":
                return <Tooltip title="Sposób odbioru nie ustalony"><QuestionMarkRoundedIcon /></Tooltip>;
            case "FREE":
                return <Tooltip title="Darmowy"><MoneyOffRoundedIcon /></Tooltip>;
            default:
                return <Tooltip title="Nie wybrano"><DisabledByDefaultRoundedIcon /></Tooltip>;
        }
    }
    return (<div style={{ margin: "auto" }}>
        <TransportCellIcon value={props.formattedValue} />
    </div>)
}
export function productCellRenderer(props) {
    function TrueFalseIcon(props) {
        return (props.value ? <CheckIcon /> : <CloseIcon />)
    }
    return (
        <Table sx={{ width: "100%" }} size="small" aria-label="a dense table">
            {/* <TableHead>
                <TableRow>
                    <TableCell>Nazwa</TableCell>
                    <TableCell align="center">Ilosc</TableCell>
                    <TableCell align="center">Status</TableCell>
                    <TableCell align="center">FSC</TableCell>
                    <TableCell align="center">Awizo</TableCell>
                </TableRow>
            </TableHead> */}
            <TableBody>
                {
                    props.formattedValue.map((product, index) => (
                        <TableRow
                            sx={{ '&:last-child td, &:last-child th': { border: 0 }, '&>td': { maxWidth: "100px", width: "100px", padding: "0px", wordBreak: "break-word" } }}
                        >
                            <TableCell align="center">
                                {product['product_name']}
                            </TableCell>
                            <TableCell align="center">
                                {product['quantity']} szt.
                            </TableCell>
                            <TableCell align="center">
                                {productStatusToInfo(product)}
                            </TableCell>
                            <TableCell align="center">
                                {
                                    product["fsc"] && <div style={{ color: "green" }}>FSC</div>
                                }
                            </TableCell>
                            <TableCell align="center">
                                {
                                    product["awizo"] && <div style={{ color: "green" }}>Awizo</div>
                                }
                            </TableCell>
                            <TableCell align="center">
                                {
                                    product["tech_card_printed"] && <Tooltip title={`Karta technologiczna wydrukowana`}><PrintOutlinedIcon color="success" /></Tooltip>
                                }
                            </TableCell>
                            <TableCell align="center">
                                {
                                    (product["invoice_number"] && product["invoice_number"] != "") && <div style={{ color: "green" }}>
                                        <div>Nr Faktury</div>
                                        <div>
                                            {product["invoice_number"]}
                                            {
                                                product["invoice_comment"] && <Tooltip
                                                    title={`Faktura - ${product["invoice_comment"]}`}>
                                                    <ModeCommentOutlinedIcon fontSize="small" sx={{ color: "green" }} />
                                                </Tooltip>
                                            }
                                        </div>

                                    </div>
                                }
                                {
                                    (product["packaging"] == true && product["invoice_number"] == "") && <div style={{ color: "red" }}> Brak faktury </div>
                                }
                            </TableCell>
                            <TableCell align="center">
                                {
                                    product["no_invoice_for_trader"] && <Tooltip title={`Brak faktury dla handlowca`}><ThumbDownIcon color="error" /></Tooltip>
                                }
                                {
                                    (product["trader_checked_invoice"] && !product["no_invoice_for_trader"]) && <Tooltip title={`Handlowiec sprawdził fakture`}><ThumbUpIcon color="success" /></Tooltip>
                                }
                            </TableCell>
                        </TableRow>
                    ))
                }
            </TableBody>
        </Table>
    )
}

export function productStatusToInfo(product) {
    let status = product["status"];
    switch (parseInt(status)) {
        case -1:
            return (<div style={{ color: "purple" }}>Brak Plikow</div>)
        case 0:
            return (<div style={{ color: "orange" }}>Pliki do sprawdzenia</div>)
        case 1:
            return (<div style={{ color: "green" }}>Pliki poprawne</div>)
        case 2:
            return (<div style={{ color: "red" }}>Czeka na odpowiedz administratora</div>)
        case 3:
            return (<div style={{ color: "green" }}>W realizacji</div>)
        case 4:
            return (<div style={{ color: "black" }}>Gotowe</div>)
        case 5:
            return (<div style={{ color: "black" }}>Odebrane</div>)
        default:
            return (<div style={{ color: "red" }}>Nieobsługiwany kod statusu</div>)
    }
}
export function productFilesTypeToInfo(product) {
    switch (product.files.type) {
        case "link":
            return (<span>Pliki link</span>)
        case "cloud":
            return (<span>Pliki dysk sieciowy</span>)
        case "other":
            return (<span>Pliki inne</span>)
        case "ftp":
            return (<span>FTP</span>)
        case "none":
            return (<span>Brak plikow</span>)
        default:
            return (<span style={{ color: "red" }}>Nieobsługiwany typ plików</span>)
    }
}
const columnGroupingModel = [
    {
        groupId: "Dane dostawy",
        children: [
            { field: 'client.delivery.login/email' },
            { field: 'client.delivery.name' },
            { field: 'client.delivery.surname' },
            { field: 'client.delivery.zip_code' },
            { field: 'client.delivery.address' },
            { field: 'client.delivery.city' },
        ]
    },
    {
        groupId: "Dane kontaktowe",
        children: [
            { field: 'client.contact.name' },
            { field: 'client.contact.surname' },
            { field: 'client.contact.login/email' },
            { field: 'client.contact.mobile_phone' },
        ]
    },
    {
        groupId: "Dane faktury",
        children: [
            { field: 'client.invoice.company' },
            { field: 'client.invoice.NIP' },
            { field: 'client.invoice.address' },
            { field: 'client.invoice.zip_code' },
            { field: 'client.invoice.city' },
        ]
    }
]
const clientInputs = {
    "Dane faktury": [
        // { type: TextField, props: { label: "Firma", name: "invoice.company", dataname: "basic.company" } },
        {
            type: AutocompleteText,//Szablon dla rzeczy typu dlugpis itd.
            statechanger: true,
            props: {
                queryPath: '/clients', serverOptions: true, label: "Firma", name: "invoice.company",
                searchBy: "basic.company",
                searchOperator: "contains",
                optionLabel: ["basic.company"],
                autocomplete: ['basic.company', 'basic.NIP', 'basic.address', 'basic.zip_code', 'basic.city', 'basic.name', 'basic.surname', 'basic.login/email', 'basic.mobile_phone', '_id'],
                dataname: "basic.company"
            }
        },
        { type: TextField, props: { label: "NIP", name: "invoice.NIP", dataname: "basic.NIP" } },
        { type: TextField, props: { label: "Adres", name: "invoice.address", dataname: "basic.address" } },
        { type: TextField, props: { label: "Kod pocztowy", name: "invoice.zip_code", dataname: "basic.zip_code" } },
        { type: TextField, props: { label: "Miasto", name: "invoice.city", dataname: "basic.city" } },
    ],
    "Dane kontaktowe": [
        { type: TextField, props: { label: "Imię", name: "contact.name", dataname: "basic.name" } },
        { type: TextField, props: { label: "Nazwisko", name: "contact.surname", dataname: "basic.surname" } },
        { type: TextField, props: { label: "Login/Email", name: "contact.login/email", dataname: "basic.login/email" } },
        { type: TextField, props: { label: "Telefon", name: "contact.mobile_phone", dataname: "basic.mobile_phone" } },
    ],
    "Adres": [
        { type: TextField, props: { label: "Firma", name: "delivery.company" } },
        { type: TextField, props: { label: "Imię", name: "delivery.name" } },
        { type: TextField, props: { label: "Nazwisko", name: "delivery.surname" } },
        { type: TextField, props: { label: "Adres", name: "delivery.address" } },
        { type: TextField, props: { label: "Kod pocztowy", name: "delivery.zip_code" } },
        { type: TextField, props: { label: "Miasto", name: "delivery.city" } },//Przycisk usuwa dane wszystkie z kolumny checkbox i pole plik na wiele adres 
    ]
}
const traderInputs = [//Wszyscy handlowcy z gory w liscie
    {
        type: AutocompleteText,
        props: {
            queryPath: '/traders', serverOptions: true, label: "Handlowiec", name: "trader_full_name", required: true,
            searchBy: "surname",
            optionLabel: ["name", "surname"],
            autocomplete: ['name', 'surname', '_id', 'relationId']
        }
    },
]
//TODO handlowiec szukanie imie i nazwisko dane: imie nazwisko
const transportInputs = [
    { type: DateField, props: { label: "Data odbioru", name: "completion_date", required: true } },
    { type: Checkbox, props: { label: "Ścisła data obioru", name: "deadline" } },
    {
        type: AutocompleteText,
        props: {
            label: "Transport", name: "transport", dataname: 'transport.transport',
            options: [
                { label: "Odbiór Osobisty", value: "PERSONAL" },
                { label: "Wysyłka Kurierem", value: "COURIER" },
                { label: "Transport dedykowany", value: "DEDICATED" },
                { label: "Zawozimy", value: "OWN" },
                { label: "Sposób odbioru nie ustalony", value: "TO_BE_AGREE" },
                { label: "Darmowy", value: "FREE" },
            ]
        }
    },
    { type: TextField, props: { label: "Cena transportu (netto)", name: "transport_price" } }, //TODO
    { type: TextField, props: { label: "Ilosc paczek", name: "packages", required: true, type: "number", value: 0 } }, //TODO >=0
    { type: TextField, props: { label: "Ilosc palet", name: "pallets", required: true, type: "number", value: 0 } }, //TODO >=0
]
export const commentsList = [
    { label: "Graficy", name: "graphic_designers" },
    { label: "Druk", name: "printing" },
    { label: "Introligatornia", name: "book_bindery" },
    { label: "Pakowanie", name: "packing" },
    { label: "Magazyn", name: "warehouse" },
    { label: "Faktury", name: "invoices" },
];
const productInputs = {
    "Dane": [
        { type: TextField, props: { label: "Nazwa produktu", name: "product_name", required: true } },
        { type: TextField, props: { label: "KOD", name: "KOD" } },
        { type: TextField, props: { label: "PO", name: "PO" } },
        { type: TextField, props: { label: "PMD", name: "PMD" } },
        { type: TextField, props: { label: "Nakład", name: "quantity", required: true } },
        {
            type: AutocompleteText,//Szablon dla rzeczy typu dlugpis itd.
            statechanger: true,
            props: {
                queryPath: '/calculations', serverOptions: true, label: "Numer kalkulacji", name: "calculation_number",
                searchBy: "calculation_number",
                optionLabel: ["calculation_number"],
                autocomplete: ['calculation_number', 'weight', 'product_name', 'quantity', 'price_netto', 'description', 'production']
            }
        },
        { type: TextField, props: { label: "Cena netto", name: "price_netto", value: 0 } },
        { type: TextField, props: { label: "Kwota nadwyżki", name: "surplus_amount", value: 0 } },
        {
            type: AutocompleteText,
            props: {
                label: "VAT", name: "vat_value", required: true, value: '1.23', // 23% default
                options: [
                    { label: "23% standard", value: "1.23" },
                    { label: "8% czasopisma", value: "1.08" },
                    { label: "5% książki", value: "1.05" },
                    { label: "0% WDD", value: "1" },
                ]
            }
        },
        { type: TextField, props: { label: "Waga", name: "weight" } },
        { type: TextField, props: { label: "Produkcja", name: "production", style: { "display": "none" } } },
        { type: TextField, props: { multiline: true, fullWidth: true, rows: 10, label: "Opis", name: "description" } },
        { type: Checkbox, props: { label: "FSC", name: "fsc" } },
        { type: Checkbox, props: { label: "Awizo", name: "awizo" } },
        { type: Checkbox, props: { label: "Brak faktury", name: "no_invoice_for_trader" } },
        { type: Checkbox, props: { label: "Ukryj produkt", name: "hidden_for_trader" } },
    ],
    "Pliki": [
        {
            type: AutocompleteText,
            props: {
                onChange: (event, value, setInputValue) => {
                    console.log(value)
                    if (value.value == "none") {
                        console.log("status -1")
                        setInputValue("status", -1)
                    } else {
                        console.log("status 0")
                        setInputValue("status", 0)
                    }
                },
                label: "Typ plikow", name: "files.type", required: true, value: "none",
                options: [
                    { label: "Pliki link", value: "link" },
                    { label: "Pliki dysk sieciowy", value: "cloud" },
                    { label: "Pliki inne", value: "other" },
                    { label: "FTP", value: "ftp" },
                    { label: "Brak plikow", value: "none", color: "red" },
                ]
            }
        },
        { type: TextField, props: { label: "Link", name: "files.info" } },
    ],
    "Faktura": [
        { type: TextField, props: { label: "Nr Faktury", name: "invoice_number" } },
        { type: TextField, props: { label: "Uwagi Faktura", name: "invoice_comment" } },
        { type: TextField, props: { label: "Email", name: "invoice_email", dataname: "payment.email" } },
    ]
}
export default function Main(props) {
    const { clientId, lookupId } = useParams();
    const [saving, setSaving] = useState(false);
    const [loading, setLoading] = useState(false);

    const [clientData, setClientData] = useState({});
    const [transportData, setTransportData] = useState({});
    const [traderData, setTraderData] = useState({});
    const [commentsData, setCommentsData] = useState({});
    const [productsData, setProductsData] = useState([]);
    const [orderData, setOrderData] = useState({});
    const [filesData, setFilesData] = useState({});
    const [initialOrderSignature, setInitialOrderSignature] = useState(null);
    const [hasExternalChanges, setHasExternalChanges] = useState(false);
    const hasShownExternalChangeRef = useRef(false);

    const archiveOrOrders = props.archive ? 'archive' : 'orders';
    const productsTabRef = useRef();
    const formRef = useRef();
    const fileAttachmentRef = useRef();
    const fileClientAttachmentRef = useRef();
    const navigate = useNavigate();
    console.log(new URL(window.location.href).searchParams.get("jwt"))

    const fetchOrderSnapshot = useCallback(async () => {
        if (!lookupId) {
            return null;
        }
        return query(`/${archiveOrOrders}?id=${lookupId}`, "GET", undefined, false);
    }, [lookupId, archiveOrOrders]);

    const applyOrderFromServer = useCallback((res) => {
        if (!res) {
            return;
        }
        const clientPayload = res.client ? {
            _id: res.client._id,
            delivery: res.client.delivery,
            invoice: res.client.invoice,
            contact: res.client.contact,
        } : {};
        setClientData(flattenObj(clientPayload));
        setTransportData(res.transport ?? {});
        setTraderData(res.trader ? { ...res.trader, trader_full_name: `${res.trader.name}-${res.trader.surname}` } : {});
        setCommentsData(res.comments ?? {});
        setFilesData(res.files ?? {});
        setProductsData(Array.isArray(res.products) ? res.products.map(product => Object.assign({}, flattenObj(product), product)) : []);
        setOrderData(res);
        const signature = stableStringify(res);
        setInitialOrderSignature(signature);
        setHasExternalChanges(false);
        hasShownExternalChangeRef.current = false;
    }, [flattenObj]);

    const refreshOrderBaseline = useCallback(async ({ withLoader = false } = {}) => {
        if (!lookupId) {
            return false;
        }
        if (withLoader) {
            setLoading(true);
        }
        try {
            const res = await fetchOrderSnapshot();
            if (!res) {
                return false;
            }
            applyOrderFromServer(res);
            return true;
        } catch (error) {
            console.error('Failed to refresh order baseline', error);
            return false;
        } finally {
            if (withLoader) {
                setLoading(false);
            }
        }
    }, [lookupId, fetchOrderSnapshot, applyOrderFromServer]);

    const ensureOrderIsFresh = useCallback(async () => {
        if (!lookupId || props.disableEdit) {
            return true;
        }
        try {
            const res = await fetchOrderSnapshot();
            if (!res) {
                return true;
            }
            const signature = stableStringify(res);
            if (initialOrderSignature && signature !== initialOrderSignature) {
                setHasExternalChanges(true);
                if (!hasShownExternalChangeRef.current) {
                    enqueueSnackbar('Zamówienie zostało zmienione przez innego użytkownika. Odśwież dane przed zapisaniem.', { variant: 'warning' });
                    hasShownExternalChangeRef.current = true;
                }
                return false;
            }
            return true;
        } catch (error) {
            console.error('Nie udało się zweryfikować aktualności zamówienia', error);
            enqueueSnackbar('Nie udało się zweryfikować aktualności zamówienia. Spróbuj ponownie.', { variant: 'error' });
            return false;
        }
    }, [lookupId, props.disableEdit, fetchOrderSnapshot, initialOrderSignature, enqueueSnackbar]);

    const handleReloadLatest = useCallback(async () => {
        if (!lookupId) {
            return;
        }
        const confirmed = window.confirm('Załadowanie najnowszej wersji spowoduje utratę niezapisanych zmian. Kontynuować?');
        if (!confirmed) {
            return;
        }
        const refreshed = await refreshOrderBaseline({ withLoader: true });
        if (refreshed) {
            enqueueSnackbar('Załadowano najnowsze dane zamówienia.', { variant: 'success' });
        } else {
            enqueueSnackbar('Nie udało się pobrać najnowszej wersji zamówienia.', { variant: 'error' });
        }
    }, [lookupId, refreshOrderBaseline, enqueueSnackbar]);

    const handleTabAdd = () => {
        console.log(productsData.length)
        setProductsData([...productsData, { id: productsData[productsData.length - 1] ? productsData[productsData.length - 1].id + 1 : 1, "payment.email": clientData["payment.email"] }]);
        productsTabRef.current.setPage(productsData.length)
    };

    const handleTabDelete = (n) => {
        productsData.splice(n, 1);
        setProductsData([...productsData]);
    }

    const copyUserDataToDeliveryAddress = () => {
        clientData['delivery.address'] = clientData['invoice.address'];
        clientData['delivery.company'] = clientData['invoice.company'];
        clientData['delivery.zip_code'] = clientData['invoice.zip_code'];
        clientData['delivery.city'] = clientData['invoice.city'];
        setClientData({ ...clientData })
    }

    useEffect(() => {
        console.log("zmiana")
    }, [clientData])

    useEffect(() => {
        let active = true;

        const loadClientData = async () => {
            setLoading(true);
            try {
                const res = await query(`/clients?id=${clientId}`, "GET", undefined, false);
                if (!active) {
                    return;
                }
                setClientData(flattenObj(res));
            } catch (error) {
                console.error('Failed to load client data', error);
            } finally {
                if (active) {
                    setLoading(false);
                }
            }
        };

        const loadOrderData = async () => {
            setLoading(true);
            try {
                const res = await fetchOrderSnapshot();
                if (!active) {
                    return;
                }
                applyOrderFromServer(res);
            } catch (error) {
                console.error('Failed to load order data', error);
            } finally {
                if (active) {
                    setLoading(false);
                }
            }
        };

        if (clientId) {
            loadClientData();
        } else if (lookupId) {
            loadOrderData();
        } else {
            setInitialOrderSignature(null);
            setHasExternalChanges(false);
            hasShownExternalChangeRef.current = false;
        }

        return () => {
            active = false;
        };
    }, [clientId, lookupId, fetchOrderSnapshot, applyOrderFromServer]);

    useEffect(() => {
        if (!lookupId || props.disableEdit || !initialOrderSignature) {
            return;
        }
        let cancelled = false;

        const poll = async () => {
            try {
                const res = await fetchOrderSnapshot();
                if (cancelled || !res) {
                    return;
                }
                const signature = stableStringify(res);
                if (initialOrderSignature && signature !== initialOrderSignature) {
                    setHasExternalChanges(true);
                    if (!hasShownExternalChangeRef.current) {
                        enqueueSnackbar('Zamówienie zostało zmienione przez innego użytkownika.', { variant: 'warning' });
                        hasShownExternalChangeRef.current = true;
                    }
                }
            } catch (error) {
                console.error('Order freshness check failed', error);
            }
        };

        const intervalId = setInterval(poll, ORDER_POLL_INTERVAL);

        return () => {
            cancelled = true;
            clearInterval(intervalId);
        };
    }, [lookupId, props.disableEdit, initialOrderSignature, fetchOrderSnapshot, enqueueSnackbar]);

    function validateForm() {
        productsData.forEach((product, index) => {
            Object.keys(product).forEach((inputName) => {
                let component = productInputs["Dane"].find(c => c.props.name == inputName);
                console.log(inputName, component, product)
                if (component === undefined) return;
                if (component.props.required && (product[inputName] === undefined || product[inputName] === "")) {
                    productsTabRef.current.setPage(index, () => formRef.current.reportValidity());
                    throw ("Form validation error");
                }
            })
        })
    }
    const handleSubmit = async (e) => {
        e.preventDefault();
        setSaving(true);
        try {
            validateForm();
            if (lookupId && !props.disableEdit) {
                const upToDate = await ensureOrderIsFresh();
                if (!upToDate) {
                    return;
                }
            }
            console.log(productsData)
            let clientData2 = unflattenObject(clientData);
            let data = {
                client: {
                    _id: clientData2["_id"],
                    delivery: clientData2.delivery,
                    invoice: clientData2.invoice,
                    contact: clientData2.contact,
                },
                transport: transportData,
                trader: traderData,
                comments: commentsData,
                files: filesData,
                products: productsData.map(product => {
                    console.log({ ...product })
                    let notFlattedProduction = { ...product.production }
                    let newProduct = unflattenObject(product);
                    newProduct.production = notFlattedProduction;
                    return newProduct;
                })
            };
            console.log(data)
            console.log(data.products)
            const response = await query('/orders', lookupId ? 'PATCH' : 'POST',
                lookupId ? {
                    id: lookupId,
                    data: data
                } :
                    data
                , true);
            window.top.postMessage('SUBMIT_SUCCESS', '*')
            if (!lookupId) {
                navigate(`/orders/${response.id}/edit`)
            } else {
                const refreshed = await refreshOrderBaseline();
                if (!refreshed) {
                    enqueueSnackbar('Nie udało się odświeżyć danych zamówienia po zapisie. Odśwież stronę ręcznie.', { variant: 'warning' });
                }
            }
        } catch (err) {
            console.error(err);
        } finally {
            setSaving(false);
        }
    }

    if (lookupId || clientId) return (loading ? <CircularProgress /> :
        <Grid component="form" ref={formRef} onSubmit={handleSubmit} noValidate columnSpacing={{ xs: 1, sm: 2, md: 3 }} item >
            <Grid xs={12} item className="container" sx={{ marginBottom: "20px" }} container alignItems={"center"}>
                <Button variant="contained" startIcon={<KeyboardReturnIcon />} component={Link} to={`/${archiveOrOrders}`}>Cofnij</Button>
                <Typography variant="h6" textAlign="left" style={{ marginLeft: "10px" }}>
                    {
                        lookupId ? `Zamowienie o id: ${lookupId}`
                            : `Dodaj zamowienie dla klienta o id: ${clientId}`
                    }
                </Typography>
            </Grid>
            {hasExternalChanges && (
                <Grid xs={12} item className="container" sx={{ marginBottom: "20px" }}>
                    <Alert
                        severity="warning"
                        action={!props.disableEdit ? (
                            <Button color="inherit" size="small" onClick={handleReloadLatest}>
                                Odśwież
                            </Button>
                        ) : undefined}
                    >
                        Zamówienie zostało zmienione przez innego użytkownika. Odśwież dane przed zapisaniem, aby uniknąć nadpisania zmian.
                    </Alert>
                </Grid>
            )}
            <Grid xs={12} item className="container" sx={{ marginBottom: "20px", paddingLeft: "4px" }} container>
                <Grid xs={12} item container className="container">Przypisany klient/firma o id: {orderData && orderData.client && orderData.client._id ? `${orderData.client._id} (${orderData.client.invoice.company})` : ""}</Grid>
                <InputRow inputColumns={clientInputs} data={clientData} disabled={props.disableEdit} container={false} useDatanameFirst={true} />
                {
                    !props.disableEdit && <Button sx={{ marginLeft: "16px", marginBottom: "10px" }} onClick={copyUserDataToDeliveryAddress} variant="contained">Kopiuj dane faktury do adresu</Button>
                }
            </Grid>

            <Grid xs={12} item container sx={{ marginBottom: "20px" }} spacing={3} alignItems="stretch">
                <Grid xs={4} item >
                    <Box className="container" sx={{ height: '100%', boxSizing: "border-box" }}>
                        <Typography variant="h6" textAlign="left">
                            Transport, płatności
                        </Typography>
                        <Grid xs={12} item container>
                            <InputColumn fields={transportInputs} data={transportData} disabled={props.disableEdit} xs={12} />
                        </Grid>
                    </Box>
                </Grid>
                <Grid xs={4} item >
                    <Box className="container" sx={{ height: '100%', boxSizing: "border-box" }}>
                        <Typography variant="h6" textAlign="left">
                            Handlowiec
                        </Typography>
                        <InputColumn fields={traderInputs} data={traderData} disabled={props.disableEdit} xs={12} />
                    </Box>
                </Grid>
                <Grid xs={4} item >
                    <Box className="container" sx={{ height: '100%', boxSizing: "border-box" }}>
                        <Typography variant="h6" textAlign="left">
                            Pliki
                        </Typography>
                        <React.Fragment>
                            {
                                (lookupId && !props.disableEdit) ? <Button
                                    variant="contained"
                                    component="label"
                                    startIcon={<CloudUploadIcon />}
                                    sx={{ alignSelf: "right" }}
                                >
                                    Załącz plik
                                    <input
                                        type="file"
                                        name="attachment"
                                        startIcon={<CloudUploadIcon />}
                                        ref={fileAttachmentRef}
                                        onChange={async () => {
                                            const files = fileAttachmentRef.current.files;
                                            // make sure that it's not null or undefined
                                            if (files) {
                                                var myHeaders = new Headers();
                                                myHeaders.append("Authorization", `Bearer ${localStorage.getItem("accessToken")}`);

                                                var formdata = new FormData();
                                                formdata.append("attachment", files[0]);

                                                var requestOptions = {
                                                    method: 'POST',
                                                    headers: myHeaders,
                                                    body: formdata
                                                };
                                                fetch(`${config.apiPath}/orders/${orderData.relationId}/attachment`, requestOptions).then(res => {
                                                    switch (res.status) {
                                                        case 200:
                                                            enqueueSnackbar("Sukces!", { variant: "success" })
                                                            break;
                                                        case 413:
                                                            enqueueSnackbar("Za duzy plik!", { variant: "error" })
                                                            break;
                                                        case 401:
                                                            localStorage.clear('accessToken');
                                                            window.location.href = '/';
                                                            break;
                                                    }

                                                })
                                            }
                                        }}
                                        hidden
                                    />
                                </Button> : <Typography sx={{ color: "red" }}>Utworz zamowienie by dodac pliki</Typography>
                            }
                        </React.Fragment>
                        <React.Fragment>
                            {
                                (orderData.files && orderData.files.attachmentPath) && (
                                    <Link to={`${config.apiPath}${orderData.files.attachmentPath}`} target="_blank" download>
                                        {
                                            orderData.files.attachmentPath.split('/')[orderData.files.attachmentPath.split('/').length - 1]
                                        }
                                    </Link>
                                )
                            }
                        </React.Fragment>
                    </Box>
                </Grid>

            </Grid>
            <Grid xs={12} item container sx={{ marginBottom: "20px" }} spacing={3}>
                <Grid xs={6} item >
                    <Box className={"container"} sx={{ height: '100%', boxSizing: "border-box" }}>
                        <Typography variant="h6" textAlign="left">
                            Komentarze
                        </Typography>
                        <CommentsTabs disableEdit={props.disableEdit} data={commentsData} />
                    </Box>
                    <Grid />
                </Grid>
                <Grid xs={6} item >
                    <Box className={"container"} sx={{ height: '100%', boxSizing: "border-box" }}>
                        <Typography variant="h6" textAlign="left">
                            Wiadomosc od klienta
                        </Typography>
                        <TextField multiline fullWidth rows={5} placeholder="Wiadomosc od klienta" defaultValue={commentsData.client}
                            onChange={(event) => {
                                commentsData.client = event.target.value
                                console.log(commentsData)
                            }} />
                        {
                            (lookupId && !props.disableEdit) ? (
                                <Button
                                    variant="contained"
                                    component="label"
                                    startIcon={<CloudUploadIcon />}
                                    sx={{ alignSelf: "right" }}
                                >
                                    Załącz plik
                                    <input
                                        type="file"
                                        name="clientAttachments"
                                        startIcon={<CloudUploadIcon />}
                                        ref={fileClientAttachmentRef}
                                        onChange={async () => {
                                            const files = fileClientAttachmentRef.current.files;
                                            // make sure that it's not null or undefined
                                            if (files) {
                                                var myHeaders = new Headers();
                                                myHeaders.append("Authorization", `Bearer ${localStorage.getItem("accessToken")}`);

                                                var formdata = new FormData();
                                                formdata.append("clientAttachments", files[0]);

                                                var requestOptions = {
                                                    method: 'POST',
                                                    headers: myHeaders,
                                                    body: formdata
                                                };
                                                fetch(`${config.apiPath}/orders/${orderData.relationId}/clientAttachments`, requestOptions).then(res => {
                                                    switch (res.status) {
                                                        case 200:
                                                            enqueueSnackbar("Sukces!", { variant: "success" })
                                                            break;
                                                        case 413:
                                                            enqueueSnackbar("Za duzy plik!", { variant: "error" })
                                                            break;
                                                        case 401:
                                                            localStorage.clear('accessToken');
                                                            window.location.href = '/';
                                                            break;
                                                    }

                                                })
                                            }

                                            //fileAttachmentFormRef.current.submit();
                                        }}
                                        hidden
                                    />
                                </Button>
                            ) : <Typography sx={{ color: "red" }}>Utworz zamowienie by dodac pliki</Typography>
                        }
                        {
                            (orderData.files && orderData.files.clientAttachmentsPath) && (
                                <Link to={`${config.apiPath}${orderData.files.clientAttachmentsPath}`} target="_blank" download>
                                    {
                                        orderData.files.clientAttachmentsPath.split('/')[orderData.files.clientAttachmentsPath.split('/').length - 1]
                                    }
                                </Link>
                            )
                        }
                    </Box>
                </Grid>
            </Grid>
            <Grid xs={12} item container className="container" sx={{ marginBottom: "20px" }}>
                <Typography variant="h6" textAlign="left">
                    Produkty
                </Typography>
                <TabsInput handleTabAdd={!props.disableEdit && handleTabAdd} handleTabDelete={!props.disableEdit && handleTabDelete} ref={productsTabRef}>
                    {
                        productsData.map((value, index) => {
                            console.log(`products.${index}.${JSON.stringify(productsData[index])}`)
                            return <React.Fragment index={index} tablabel={`Produkt ${value.id}`}>
                                <InputRow
                                    key={`products.${index}.${JSON.stringify(productsData[index])}`}
                                    inputColumns={productInputs} data={productsData[index]}
                                    disabled={props.disableEdit} sx={{ marginBottom: "0px" }} />
                                {
                                    lookupId && <WZTrackingBundle orderId={orderData._id} order={orderData} product={productsData[index]} editable={false} />
                                }
                            </React.Fragment>
                        })
                    }
                </TabsInput>
            </Grid>

            {
                !props.disableEdit && <Fab type="submit" color="primary" aria-label="add" disabled={saving} sx={{ position: "fixed", left: "10px", bottom: "10px", height: "70px", width: "70px" }}>
                    {
                        lookupId ? <SaveIcon fontSize="large" /> : <AddIcon fontSize="large" />
                    }
                </Fab>
            }
        </Grid >
    )
    return (
        <OrdersDataGrid />
    );
}
export function CommentsTabs(props) {
    return <TabsInput>
        {commentsList.map((e, index) => {
            return <TextField index={index} tablabel={e.label} key={"comments." + e.name} defaultValue={props.data[e.name]}
                name={e.name} multiline fullWidth rows={5} placeholder={`Komentarz dla ${e.label}`}
                onChange={(event) => props.data[event.target.name] = event.target.value} disabled={props.disableEdit} />
        })
        }
    </TabsInput>
}
export function OrdersDataGrid(props) {// Used by OrdersFiles
    return (
        <DefaultDataGrid
            addingTool={false}
            getRowHeight={() => 'auto'}
            sortmodel={{ field: 'creation_date', sort: 'desc' }}
            columnGroupingModel={columnGroupingModel}
            columns={columns}
            queryPath="/orders"
            additionalActionButtons={
                [
                    {
                        icon: ArchiveOutlinedIcon, iconTooltip: `Przenieś do archiwum zamówienie id: *id*`, label: "Archive", onClick: async (id) => {
                            await query(`/archive/catch/order/${id}`, 'PATCH');
                            window.location.reload();
                        }
                    },
                    {
                        icon: KeyIcon, iconTooltip: `Karta technologiczna id: *id*`, label: "TechCard", onClick: async (id) => {
                            window.open('https://produkcja.patentdruk.pl/admin_panel/checkStatus/StatusTable/?nr_zam=' + id, '_blank');
                        }
                    },
                    { icon: SettingsOutlinedIcon, iconTooltip: `Zarzadzaj zamówieniem id: *id*`, linkTo: `/orders/*id*/manage`, label: "Files" },
                ]}
            {...props}
        />

    )
}


